module.exports = __webpack_public_path__ + "img/product-m-val3.d0aa9f37.png";